
import Vue from 'vue';
export default Vue.extend({
  props: {
    variant: { type: String, required: true, default: 'primary' },
    disabled: { type: Boolean, required: false },
    iconName: { type: String, required: false },
    iconPos: { type: String, required: false },
    url: { type: String, required: false },
    target: { type: String, required: false },
    label: { type: String, required: true },
    type: { type: String || null, default: null },
    isSubmit: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {
    getType(): string {
      if (this.type) return this.type;
      return this.url && !this.url.includes('://') && !this.url.includes('mailto:') && !this.url.includes('tel:')
        ? 'nuxt-link'
        : 'a';
    },
    href(): string | undefined {
      return this.getType === 'a' ? this.url : undefined;
    },
    to(): string | undefined {
      return this.getType !== 'a' && this.url ? this.url : undefined;
    },
    getLabel(): any {
      return this.$slots.default || this.label;
    },
  },
});
